module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BreadcrumbsLayout', {
    attrs: {
      "bg": "grey",
      "breadcrumbs": _vm.breadcrumbs
    }
  }, [_c('ListLayout', [_c('CatalogSort', {
    attrs: {
      "slot": "sort",
      "items": _vm.sortList
    },
    slot: "sort"
  }), (_vm.isContainData) ? [_c('ListPageLayout', {
    attrs: {
      "slot": "list"
    },
    slot: "list"
  }, [_c('FilterYellow', _vm._b({}, 'FilterYellow', _vm.filterProps, false)), _vm._l((_vm.items), function(item) {
    return _c('ProfessionListCard', _vm._b({
      key: item.id
    }, 'ProfessionListCard', item, false))
  })], 2), _c('PaginationLayout', {
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }, [(_vm.pagesCount > 1) ? _c('PaginatorDefault', {
    attrs: {
      "count": _vm.pagesCount,
      "current": parseInt(_vm.page),
      "max": 6
    }
  }) : _vm._e(), _c('SelectCount', {
    attrs: {
      "slot": "right",
      "options": _vm.pageLimits,
      "value": _vm.limit,
      "text": "Профессий на странице"
    },
    on: {
      "change": _vm.pageLimitChange
    },
    slot: "right"
  })], 1)] : _c('SiteMap', {
    attrs: {
      "slot": "list",
      "title": "К сожалению, нам не удалось найти ничего идеально подходящего.",
      "map": _vm.mainNav
    },
    slot: "list"
  }, [_c('FilterYellow', _vm._b({
    attrs: {
      "slot": "sidebar"
    },
    slot: "sidebar"
  }, 'FilterYellow', _vm.filterProps, false)), _vm._v("Попробуйте воспользовать формой слева используя менее узкие критерии подбора\nили воспользуйтесь списком категорий для поиска программы.")], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54daddee","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/professions/list/ProfessionsList.vue
// module id = e57989c3ae42cf91513a
// module chunks = 32